import watchUtils = require("esri/core/watchUtils");
import FeatureLayer = require("esri/layers/FeatureLayer");
import GroupLayer = require("esri/layers/GroupLayer");
import BuildPopups from "./buildPopups";
import * as layerSource from "./layerSource";

export const stateStructuresLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.StateStructuresLayer,
  visible: false,
  // outFields: ["*"],
});

export const localStructuresLayer = new FeatureLayer({
  url: layerSource.serverUrl,
  layerId: layerSource.LocalStructuresLayer,
  // outFields: ["*"],
  visible: false,
});

export const structuresGroupLayer = new GroupLayer({
  title: "Structures",
  id: "08 - Structures",
  visible: true,
  visibilityMode: "independent",
  layers: [localStructuresLayer, stateStructuresLayer]
});

structuresGroupLayer.layers.forEach(layer => {
  watchUtils.whenTrueOnce(layer, "loaded", () => {
    layer.title = (layer as FeatureLayer).sourceJSON.name;
    BuildPopups.buildPopupIfLoaded(layer as FeatureLayer);
  });
});
